import React from "react";
import Automationone from "../components/Section/Suspension-&-Brake-one"
import Automationtwo from "../components/Section/Suspension-&-Brake-two"

function Suspence() {
 

  return (
    <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">
    
        <Automationone />
        <Automationtwo />
      
    </div>
  );
}

export default Suspence;